import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import xlsx from 'xlsx';
import { isCardNo } from '@/utils/validate';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import { batchVerify, batchImport, getPersonnelDetail } from '../request';
import { getOccupationResource } from '../../homeManage/request';
export default {
  props: {
    importVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      current: 0,
      importStatus: 'BEFOREUPLOAD',
      steps: [{
        title: '上传文件'
      }, {
        title: '数据预览'
      }],
      fileList: [],
      columns: [{
        slots: {
          title: '工种'
        },
        dataIndex: 'occupation',
        key: 'occupation',
        align: 'center'
      }, {
        slots: {
          title: '姓名'
        },
        dataIndex: 'name',
        key: 'name',
        align: 'center'
      }, {
        slots: {
          title: '证件类型'
        },
        dataIndex: 'identificationType',
        key: 'identificationType',
        align: 'center'
      }, {
        slots: {
          title: '证件号码'
        },
        dataIndex: 'idNumber',
        key: 'idNumber',
        align: 'center'
      }, {
        slots: {
          title: '责任起期'
        },
        dataIndex: 'startAt',
        key: 'startAt',
        align: 'center'
      }, {
        slots: {
          title: '保费'
        },
        dataIndex: 'premium',
        key: 'premium',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 180,
        key: '9'
      }],
      dataInfo: [],
      fileData: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共') + total + this.$t('条')}`;
        }
      },
      editVisible: false,
      editLine: -1,
      form: {
        occupation: undefined,
        name: undefined,
        identificationType: undefined,
        idNumber: undefined,
        startAt: undefined,
        premium: undefined
      },
      professionInfo: [{
        id: 1,
        customerInsuranceId: 102,
        jobNumber: 1,
        occupation: '保安'
      }],
      identificationTypeData: [{
        label: '身份证',
        value: 'IDCARD'
      }],
      disableNextButton: false,
      policyInfo: {},
      yearDays: 365
    };
  },
  computed: {
    rules() {
      return {
        occupation: [{
          required: true,
          message: this.$t('请选择') + this.$t('工种'),
          trigger: 'change'
        }, {
          min: 2,
          max: 15,
          message: this.$t('请输入长度2-15的内容')
        }],
        identificationType: [{
          required: true,
          message: this.$t('请选择') + this.$t('证件类型'),
          trigger: 'change'
        }],
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('名称')
        }, {
          min: 2,
          max: 15,
          message: this.$t('请输入长度2-15的内容')
        }],
        startAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('签约日期')
        }],
        idNumber: [{
          required: true,
          message: this.$t('请输入') + this.$t('证件号码'),
          trigger: 'blur'
        }, {
          validator: this.validateCard,
          trigger: 'blur'
        }]
      };
    }
  },
  watch: {
    importVisible: {
      async handler(newVal) {
        if (!newVal) return;
        this.fileList = [];
        this.dataInfo = [];
        this.current = 0;
        this.importStatus = 'BEFOREUPLOAD';
        this.pagination = {
          showSizeChanger: true,
          showQuickJumper: true,
          total: 0,
          pageSize: 10,
          // 每页条数
          current: 1,
          showTotal: total => {
            return `${this.$t('共') + total + this.$t('条')}`;
          }
        };
        getPersonnelDetail({
          policyId: this.$route.params.id
        }).then(res => {
          this.policyInfo = res.insuranceInfo;
          let customerInsuranceId = this.policyInfo.customerInsuranceId;
          this.getOccupation(customerInsuranceId);
          if (this.policyInfo.rate && this.policyInfo.rate === 'day') {
            //费率类型为日费率的时候保费除的时候除366
            this.yearDays = 366;
          }
        });
      }
    }
  },
  methods: {
    validateCard(rule, idcard, callback) {
      if (!isCardNo(idcard) || idcard == '') {
        callback(new Error(this.$t('请输入18位大陆身份证号')));
      } else {
        callback();
      }
    },
    getPersonResource() {
      //获取人员信息
      return new Promise((resolve, reject) => {
        getPersonnelDetail({
          policyId: this.$route.params.id
        }).then(res => {
          resolve(res);
        }).catch(e => {
          reject(e);
        });
      });
    },
    getOccupation(customerInsuranceId) {
      getOccupationResource({
        customerInsuranceId
      }).then(res => {
        if (res.length > 0) {
          this.professionInfo = res;
        }
      });
    },
    beforeUpload(file) {
      const imgReg = /(xlsx|xls)$/;
      const filename = file.name;
      const imgSuffix = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
      const isExcel = imgReg.test(imgSuffix);
      if (!isExcel) {
        this.$message.error(this.$t('请上传正确的格式'));
        return;
      }
      if (file.size > 1 * 1024 * 1024) {
        this.$message.error(this.$t('文件大小超过1M'));
        return;
      }
      this.fileList = [];
      this.fileList = [...this.fileList, file];
      return false;
    },
    back() {
      if (this.current > 0) {
        this.current--;
      }
    },
    next() {
      if (this.fileList.length === 0) {
        this.$message.error(this.$t('请上传文件') + '!');
        return;
      }
      if (this.fileData.length > 1000) {
        this.$message.error(this.$t('导入附件内人员行数不超过1000行'));
        return;
      }
      if (this.current === 0) {
        //下一步 展示表格
        if (this.tableHeader && this.tableHeader.length > 0) {
          const header = ['*工种', '*姓名', '*证件类型', '*证件号码', '*责任起期'];
          if (this.tableHeader.length !== header.length) {
            this.$message.error(this.$t('文件格式不正确'));
            return;
          } else {
            let isPass = true;
            this.tableHeader.forEach((item, index) => {
              if (item !== header[index]) {
                isPass = false;
              }
            });
            if (!isPass) {
              this.$message.error(this.$t('文件格式不正确'));
              return;
            }
          }
        }
        if (!this.tableHeader || this.tableHeader.length === 0) {
          this.$message.error(this.$t('文件格式不正确'));
          return;
        }
        this.current++;
        this.dataInfo = [];
        this.dataInfo = cloneDeep(this.fileData).map((item, index) => {
          let startAt = item['*责任起期'] ? moment(moment(new Date(item['*责任起期']).setHours(0, 0, 0, 0)).add(1, 'days')).format('YYYY-MM-DD HH:mm:ss') : '-';
          let obj = {
            occupation: item['*工种'] || '-',
            name: item['*姓名'] || '-',
            identificationType: item['*证件类型'] || '-',
            idNumber: item['*证件号码'] ? item['*证件号码'] + '' : '-',
            startAt: startAt,
            premium: '-'
          };
          obj.errorMessage = this.checkData(obj); //校验错误数据
          if (obj.errorMessage.length === 0 && obj.startAt !== '-') {
            let currentTime = new Date(obj.startAt).getTime();
            obj.premium = this.calcPrice(currentTime, this.policyInfo.endAt, this.policyInfo.premium);
          }
          return obj;
        });
      } else {
        //开始校验  校验完成导入
        let hasErr = false;
        for (let i = 0; i < this.dataInfo.length; i++) {
          var _this$dataInfo$i;
          if (((_this$dataInfo$i = this.dataInfo[i]) === null || _this$dataInfo$i === void 0 || (_this$dataInfo$i = _this$dataInfo$i.errorMessage) === null || _this$dataInfo$i === void 0 ? void 0 : _this$dataInfo$i.length) > 0) {
            hasErr = true;
            let recentErrorPage = parseInt(i / this.pagination.pageSize) + 1;
            this.pagination.current = recentErrorPage;
            break;
          }
        }
        if (!hasErr) {
          let data = cloneDeep(this.dataInfo);
          data.map(item => {
            let findOccupation = this.professionInfo.filter(i => {
              var _i$occupation, _item$occupation;
              return ((_i$occupation = i.occupation) === null || _i$occupation === void 0 ? void 0 : _i$occupation.replace(/\s/g, '')) === ((_item$occupation = item.occupation) === null || _item$occupation === void 0 ? void 0 : _item$occupation.replace(/\s/g, ''));
            });
            if (findOccupation.length > 0) {
              item.jobNumber = findOccupation[0].jobNumber;
            }
            return item;
          });
          let params = {
            policyId: this.policyInfo.id,
            personnelDetailsData: data
          };
          //导入前校验
          this.disableNextButton = true;
          batchVerify(params).then(res => {
            this.disableNextButton = false;
            if (res.status === 'FAIL') {
              this.$message.error(this.$t('数据校验未通过'));
              this.dataInfo = [...res.data];
            } else {
              this.importPersonnel();
            }
          }).catch(() => {
            this.disableNextButton = false;
          });
        } else {
          this.$message.error(this.$t('请修改完错误项后继续【下一步】'));
        }
      }
    },
    importPersonnel() {
      this.importStatus = 'UPLOAD';
      let data = cloneDeep(this.dataInfo);
      data.map((item, index) => {
        let findOccupation = this.professionInfo.filter(i => {
          var _i$occupation2, _item$occupation2;
          return ((_i$occupation2 = i.occupation) === null || _i$occupation2 === void 0 ? void 0 : _i$occupation2.replace(/\s/g, '')) === ((_item$occupation2 = item.occupation) === null || _item$occupation2 === void 0 ? void 0 : _item$occupation2.replace(/\s/g, ''));
        });
        if (findOccupation.length > 0) {
          item.jobNumber = findOccupation[0].jobNumber;
        }
        if (item.identificationType === this.identificationTypeData[0].label) {
          item.identificationType = this.identificationTypeData[0].value;
        }
        delete item.errorMessage;
        return item;
      });
      let obj = {
        policyId: this.policyInfo.id,
        personnelDetailsData: data
      };
      batchImport(obj).then(res => {
        this.importStatus = 'UPLOADCOMPLATE';
        this.current++;
        this.$emit('refreshList');
      }).catch(e => {
        this.importStatus = 'UPLOADERROR';
      });
    },
    checkData(item) {
      //校验数据是否有误
      let errorMessage = [];
      let reg = /(.){2,15}/;
      if (!reg.test(item.occupation)) {
        errorMessage.push('工种仅限输入2-15字符');
      }
      if (this.professionInfo.length > 0) {
        let findOccupation = this.professionInfo.filter(i => {
          var _i$occupation3, _item$occupation3;
          return ((_i$occupation3 = i.occupation) === null || _i$occupation3 === void 0 ? void 0 : _i$occupation3.replace(/\s/g, '')) === ((_item$occupation3 = item.occupation) === null || _item$occupation3 === void 0 ? void 0 : _item$occupation3.replace(/\s/g, ''));
        });
        if (findOccupation.length === 0) {
          errorMessage.push('工种输入值与此单元格数据不匹配');
        }
      }
      //校验身份证号
      if (item.identificationType !== this.identificationTypeData[0].label) {
        errorMessage.push('证件类型输入值与此单元格数据不匹配');
      }
      if (!reg.test(item.name)) {
        errorMessage.push('投保人仅限输入2-15字符');
      }
      if (!isCardNo(item.idNumber)) {
        errorMessage.push('身份证号有误');
      }
      //校验责任起期
      let dateReg = /[1|2]{1}\d{3}-[0|1]{1}[0-9]{1}-([0-2]{1}[0-9]{1}|[3]{1}[0-1]{1})/;
      if (!dateReg.test(item.startAt)) {
        errorMessage.push('责任起期日期格式错误');
      } else {
        let currentTime = new Date(new Date(item.startAt).setHours(0, 0, 0, 0)).getTime();
        if (this.policyInfo.declarationMethod === 'DAY') {
          let defaultTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() + 24 * 60 * 60 * 1000;
          if (currentTime !== defaultTime) {
            errorMessage.push('责任起期日期错误');
          }
        }
        if (this.policyInfo.declarationMethod === 'MONTH') {
          let startTime = new Date(moment().subtract(1, 'month').subtract(1, 'day')).getTime();
          let insuranceStartTime = moment(this.policyInfo.startAt).endOf('day');
          if (insuranceStartTime > startTime) {
            //开始日期需要在保单的申报范围内
            startTime = insuranceStartTime;
          }
          let endTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() + 24 * 60 * 60 * 1000;
          let insuranceEndTime = moment(this.policyInfo.endAt).endOf('day');
          if (endTime > insuranceEndTime) {
            //结束日期需要在保单的申报范围内
            endTime = insuranceEndTime;
          }
          if (currentTime < startTime || currentTime > endTime) {
            errorMessage.push('责任起期输入值超出该保单申报日期范围');
          }
        }
      }
      return errorMessage;
    },
    calcPrice(startTime, endTime, premium) {
      if (!premium) {
        return;
      }
      let day = (moment(moment(endTime).format('YYYY-MM-DD HH:mm:ss')).unix() * 1000 - moment(startTime).unix() * 1000) / (24 * 60 * 60 * 1000);
      let price = Math.round(Number(premium) * 100 / this.yearDays * Math.ceil(day), 2) / 100;
      return price;
    },
    remove() {
      this.tableHeader = [];
      this.fileList = [];
    },
    handleStandardTableChange(val) {
      this.pagination = val;
    },
    getClassName(item) {
      var _item$errorMessage;
      return ((_item$errorMessage = item.errorMessage) === null || _item$errorMessage === void 0 ? void 0 : _item$errorMessage.length) > 0 ? 'red-row-class' : '';
    },
    handleChange(info) {
      var _info$fileList;
      if (!info.file) {
        this.dataInfo = [];
        return;
      }
      this.tableHeader = [];
      const fileReader = new FileReader();
      fileReader.onload = e => {
        let binaryData = e.target.result;
        let workbook = xlsx.read(binaryData, {
          type: 'buffer',
          cellDates: true
        });
        const wsname = workbook.SheetNames[0]; //取第一张表
        let ref = workbook.Sheets[wsname]['!ref'].replace('A1', 'A3');
        this.tableHeader = this.getHeaderRow(workbook.Sheets[wsname]);
        this.fileData = xlsx.utils.sheet_to_json(workbook.Sheets[wsname], {
          range: ref
        }); //生成json表格内容
      };
      if ((_info$fileList = info.fileList) !== null && _info$fileList !== void 0 && _info$fileList.length) {
        fileReader.readAsArrayBuffer(info.fileList[0].originFileObj);
      }
    },
    editRecord(record, index) {
      if ((this.pagination.current - 1) * this.pagination.pageSize + index >= this.dataInfo.length) {
        this.pagination.current = this.pagination.current - 1 < 1 ? 1 : this.pagination.current - 1;
      }
      this.editLine = index;
      this.editVisible = true;
      this.$refs.dataFrom && this.$refs.dataFrom.resetFields();
      this.form.name = record['name'];
      this.form.occupation = record['occupation'];
      this.form.identificationType = record['identificationType'];
      this.form.idNumber = record['idNumber'];
      if (this.policyInfo.declarationMethod === 'DAY') {
        //日申报 责任起期为第二天零点
        this.setTime();
      }
    },
    getHeaderRow(sheet) {
      const headers = []; // 定义数组，用于存放解析好的数据
      let ref = sheet['!ref'].replace('A1', 'A3');
      const range = xlsx.utils.decode_range(ref); // 读取sheet的单元格数据
      let C;
      const R = range.s.r;
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        const cell = sheet[xlsx.utils.encode_cell({
          c: C,
          r: R
        })];
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C; // <-- replace with your desired default
        if (cell && cell.t) hdr = xlsx.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers; // 经过上方一波操作遍历，得到最终的第一行头数据
    },
    setTime() {
      //日申报设置默认的责任起期
      const nowTimeDate = new Date().getTime() + 24 * 60 * 60 * 1000;
      let startTime = moment(new Date(nowTimeDate).setHours(0, 0, 0, 0)).format('YYYY-MM-DD HH:mm:ss');
      this.$set(this.form, 'startAt', startTime);
      let endTime = this.policyInfo.endAt;
      this.form['premium'] = this.calcPrice(startTime, endTime, this.policyInfo.premium);
    },
    deleteRecord(index) {
      if ((this.pagination.current - 1) * this.pagination.pageSize + index >= this.dataInfo.length) {
        this.pagination.current = this.pagination.current - 1 < 1 ? 1 : this.pagination.current - 1;
      }
      let deleteIndex = (this.pagination.current - 1) * this.pagination.pageSize + index;
      this.dataInfo.splice(deleteIndex, 1);
    },
    handleCancel() {
      this.$emit('update:importVisible', false);
    },
    editCancel() {
      this.editVisible = false;
    },
    disabledDate(current) {
      let start = moment().subtract(1, 'month').subtract(1, 'day');
      let insuranceStartTime = moment(this.policyInfo.startAt).endOf('day');
      if (insuranceStartTime > start) {
        start = insuranceStartTime;
      }
      let insuranceEndTime = moment(this.policyInfo.endAt).endOf('day');
      let endTime = moment().add(1, 'day').endOf('day');
      if (endTime > insuranceEndTime) {
        endTime = insuranceEndTime;
      }
      return current && current > endTime || current < start;
    },
    onChangeTime(time) {
      if (!time) {
        this.$set(this.form, 'startAt', '');
        this.$set(this.form, 'premium', '');
        return;
      }
      let startAt = moment(new Date(time).setHours(0, 0, 0, 0)).format('YYYY-MM-DD HH:mm:ss');
      this.$set(this.form, 'startAt', startAt);
      let endTime = this.policyInfo.endAt;
      this.form['premium'] = this.calcPrice(startAt, endTime, this.policyInfo.premium);
    },
    handleOk() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          if (this.professionInfo.length > 0) {
            let findOccupation = this.professionInfo.filter(i => {
              var _i$occupation4, _this$form$occupation;
              return ((_i$occupation4 = i.occupation) === null || _i$occupation4 === void 0 ? void 0 : _i$occupation4.replace(/\s/g, '')) === ((_this$form$occupation = this.form.occupation) === null || _this$form$occupation === void 0 ? void 0 : _this$form$occupation.replace(/\s/g, ''));
            });
            if (findOccupation.length === 0) {
              this.$message.error(this.$t('工种输入值与此单元格数据不匹配'));
              return;
            }
          }
          if (this.form.identificationType !== this.identificationTypeData[0].label) {
            this.$message.error(this.$t('证件类型输入值与此单元格数据不匹配'));
            return;
          }
          this.editVisible = false;
          let editIndex = (this.pagination.current - 1) * this.pagination.pageSize + this.editLine;
          this.dataInfo[editIndex] = {
            name: this.form['name'],
            occupation: this.form['occupation'],
            identificationType: this.form['identificationType'],
            idNumber: this.form['idNumber'],
            startAt: this.form['startAt'],
            premium: this.form['premium']
          };
        }
      });
    },
    download() {
      //下载模板
      let url = 'https://insurforce1.oss-cn-beijing.aliyuncs.com/insurforce/policy/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E4%BA%BA%E5%91%98%E6%A8%A1%E6%9D%BF.xlsx';
      let filename = this.$t('批量导入人员模板') + '.xlsx';
      const link = document.createElement('a');
      link.style.display = 'none';
      link.setAttribute('download', filename);
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // 下载完成移除元素
      window.URL.revokeObjectURL(url); // 释放掉blob对象
    }
  }
};